<div fxFlex fxLayout="column" class="map-container">
    <div class="map-header-container">
        <div fxFlex fxLayoutAlign="center center"><h3>{{mapTitle}}</h3></div>
        <button mat-stroked-button (click)="onClose()" tabindex="-1"><mat-icon>clear</mat-icon></button>
    </div>
    <div fxLayout="column" fxFlex class="map-content">
        <div>
            <div class="region-description" [fxShow]="mapId == 1">
                <p>What is a South African Student?</p>
                <ul>
                    <li>{{screenWidth > 600 ? '*' : ''}} Have a South African ID</li>
                </ul>
            </div>
            <div class="region-description" [fxShow]="mapId == 2">
                <p>What is a Non South African ID Holder?</p>
                <ul>
                    <li>{{screenWidth > 600 ? '*' : ''}} Africa, Refugee, Asylum Seeker</li>
                    <li>{{screenWidth > 600 ? '*' : ''}} SADC</li>
                    <li>{{screenWidth > 600 ? '*' : ''}} Non SADC</li>
                </ul>
            </div>
            <div class="region-description" [fxShow]="mapId == 3">
                <p>What is an Overseas International Student?</p>
                <ul>
                    <li>{{screenWidth > 600 ? '*' : ''}} Overseas passport</li>
                    <li>{{screenWidth > 600 ? '*' : ''}} Overseas refugee</li>
                    <li>{{screenWidth > 600 ? '*' : ''}} Overseas Asylum Seeker</li>
                </ul>
            </div>
        </div>
        <div fxFlex fxLayout="row">
            <div #countries class="sadc-countries" fxHide.lt-md [style.min-width]="mapId == 2 ? '110px' : 0">
                <p><b>{{mapId == 2 ? 'SADC Countries' : ''}}&nbsp;</b></p>
                <ul fxLayoutGap="2px;">
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.AGO]="mapId == 2">{{mapId == 2 ? 'Angola' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.BWA]="mapId == 2">{{mapId == 2 ? 'Botswana' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.COM]="mapId == 2">{{mapId == 2 ? 'Comoros' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.COD]="mapId == 2">{{mapId == 2 ? 'Congo, DR' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.SWZ]="mapId == 2">{{mapId == 2 ? 'Eswatini' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.LSO]="mapId == 2">{{mapId == 2 ? 'Lesotho' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.MDG]="mapId == 2">{{mapId == 2 ? 'Madagascar' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.MWI]="mapId == 2">{{mapId == 2 ? 'Malawi' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.MUS]="mapId == 2">{{mapId == 2 ? 'Mauritius' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.MOZ]="mapId == 2">{{mapId == 2 ? 'Mozambique' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.NAM]="mapId == 2">{{mapId == 2 ? 'Namibia' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.SYC]="mapId == 2">{{mapId == 2 ? 'Seychelles' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.ZAF]="mapId == 2">{{mapId == 2 ? 'South Africa' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.TZA]="mapId == 2">{{mapId == 2 ? 'Tanzania' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.ZMB]="mapId == 2">{{mapId == 2 ? 'Zambia' : ''}}&nbsp;</li>
                    <li [style.padding-left]="mapId == 2 ? '26px' : 0" [class.ZWE]="mapId == 2">{{mapId == 2 ? 'Zimbabwe' : ''}}&nbsp;</li>
                </ul>
            </div>
            <div id="map" #map fxHide.lt-md fxFlex fxLayoutAlign="center center">
            </div>
        </div>
        <div fxLayout="column" fxHide.lt-md fxLayoutAlign="center center" class="footer-note">
            <div><p><i>Hover over the map to view country names (click to zoomin / double-click to zoomout)</i></p></div>
            <div class="legend">
                <div fxLayout="row">
                    <div fxLayoutAlign="end center"><span class="circle south_africa"></span></div>&nbsp;
                    <div fxLayoutAlign="start center"><span>South Africa</span></div>&nbsp;&nbsp;&nbsp;
                    <div fxLayoutAlign="end center"><span class="circle sadc"></span></div>&nbsp;
                    <div fxLayoutAlign="start center"><span>SADC</span></div>&nbsp;&nbsp;&nbsp;
                    <div fxLayoutAlign="end center"><span class="circle africa"></span></div>&nbsp;
                    <div fxLayoutAlign="start center"><span>Rest of Africa (Non SADC)</span></div>&nbsp;&nbsp;&nbsp;
                    <div fxLayoutAlign="end center"><span class="circle oversees"></span></div>&nbsp;
                    <div fxLayoutAlign="start center"><span>Overseas International</span></div>
                </div>
            </div>
        </div>
    </div>
</div>
